import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f6d680"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex w-100 h-100 flex-column overflow-hidden" }
const _hoisted_2 = { class: "leaflet-container d-flex justify-content-center w-100 h-100" }
const _hoisted_3 = { class: "w-250px" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-play me-2" }, null, -1))
const _hoisted_5 = { class: "d-flex flex-column mt-2 pb-2" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "leaflet-bar controlButton" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-location fs-3 fw-bolder" }, null, -1))
const _hoisted_15 = { class: "leaflet-bar h-100 overflow-hidden" }
const _hoisted_16 = { class: "primaryGradient text-white d-flex justify-content-around align-items-center w-100 h-100 bg-white" }
const _hoisted_17 = ["title"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-zoom-in fs-3 fw-bolder" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-0 h-75 border" }, null, -1))
const _hoisted_21 = ["title"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-zoom-out fs-3 fw-bolder" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "weather leaflet-bar d-flex justify-content-between align-items-start w-100 h-100 p-2 d-flex flex-column text-white" }
const _hoisted_25 = { class: "fw-bolder d-flex justify-content-center align-items-center" }
const _hoisted_26 = { class: "temperature" }
const _hoisted_27 = { class: "fs-2 ms-2" }
const _hoisted_28 = { class: "w-100 h-100 d-flex align-items-center" }
const _hoisted_29 = { class: "d-flex flex-column w-100 fs-6 fw-bolder" }
const _hoisted_30 = { class: "ms-2" }
const _hoisted_31 = { class: "ms-2" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "leaflet-bar controlButton" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-home fs-3" }, null, -1))
const _hoisted_35 = { class: "leaflet-bar controlButton" }
const _hoisted_36 = ["title"]
const _hoisted_37 = { class: "leaflet-bar controlButton" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-location fs-3 fw-bolder" }, null, -1))
const _hoisted_39 = { class: "leaflet-bar controlButton" }
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "w-100 d-flex fw-bolder justify-content-center text-white tileShortName" }
const _hoisted_42 = { class: "leaflet-bar controlButton" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "w-100 d-flex fw-bolder justify-content-center text-white tileShortName" }
const _hoisted_45 = { class: "leaflet-bar controlButton" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-toolbox fs-3" }, null, -1))
const _hoisted_47 = { class: "leaflet-bar controlButton" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-square fs-3" }, null, -1))
const _hoisted_49 = { class: "leaflet-bar controlButton" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-ruler fs-3" }, null, -1))
const _hoisted_51 = { class: "leaflet-bar controlButton" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-info fs-3" }, null, -1))
const _hoisted_53 = { class: "leaflet-bar controlButton" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-camera" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-undo" }, null, -1))
const _hoisted_56 = { class: "searchControl" }
const _hoisted_57 = { class: "searchComponent d-flex justify-content-center w-250px flex-column rounded primaryGradient me-2 overflow-hidden" }
const _hoisted_58 = { class: "d-flex justify-content-center text-white" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars fs-4" }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars fs-4" }, null, -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 0,
  class: "card result-display mt-2 w-250px"
}
const _hoisted_65 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "modal-header px-3 py-1" }
const _hoisted_77 = {
  class: "fw-bolder",
  style: {"margin":"0"}
}
const _hoisted_78 = { class: "svg-icon svg-icon-1" }
const _hoisted_79 = { class: "modal-body geoInfo p-3" }
const _hoisted_80 = { class: "mw-150px" }
const _hoisted_81 = { class: "w-100 menuBar primaryGradient d-flex justify-content-between align-items-center position-relative z-index-1 px-2" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center text-white fw-bolder fs-5" }, "MOBIFONE", -1))
const _hoisted_83 = {
  key: 0,
  class: "d-flex align-items-end h-0 position-relative z-index-2"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home fs-1 text-white" }, null, -1))
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = { class: "d-flex align-items-end h-0 position-relative z-index-2" }
const _hoisted_87 = ["title"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars fs-1 text-white" }, null, -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = ["title"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars fs-1 text-white" }, null, -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = {
  key: 0,
  class: "d-flex align-items-end h-0"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-double-up" }, null, -1))
const _hoisted_95 = { class: "ms-2" }
const _hoisted_96 = ["title"]
const _hoisted_97 = { class: "fs-6" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-location rounded-circle bg-white text-dark" }, null, -1))
const _hoisted_99 = {
  key: 1,
  class: "overflow-auto"
}
const _hoisted_100 = ["onClick"]
const _hoisted_101 = {
  class: "p-2",
  style: {"width":"calc(100% - 70px)"}
}
const _hoisted_102 = {
  class: "modal fade",
  id: "kt_modal_map",
  ref: "mapModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_103 = {
  class: /*#__PURE__*/_normalizeClass('modal-dialog modal-dialog-centered mw-1000px')
}
const _hoisted_104 = { class: "modal-content h-75 overflow-hidden" }
const _hoisted_105 = {
  class: "modal-header p-2",
  id: "kt_modal_map_header"
}
const _hoisted_106 = { class: "fw-bolder fs-2" }
const _hoisted_107 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_108 = { class: "svg-icon svg-icon-1" }
const _hoisted_109 = { class: "d-flex justify-content-between me-2 align-items-center w-100" }
const _hoisted_110 = { class: "fw-bolder" }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = ["title"]
const _hoisted_113 = { class: "fs-6" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-location rounded-circle bg-white text-dark p-1" }, null, -1))
const _hoisted_115 = ["src"]
const _hoisted_116 = { class: "w-100 my-10" }
const _hoisted_117 = { class: "text-center" }
const _hoisted_118 = {
  key: 0,
  class: "d-flex z-index-2 h-100 w-100 position-absolute justify-content-center align-items-center bg-translucent-dark"
}
const _hoisted_119 = { class: "d-flex position-absolute z-index-2 h-75 w-75 bg-dark border border-light rounded overflow-hidden fade-in iframe-content" }
const _hoisted_120 = { class: "position-absolute p-4 z-index-3 d-flex align-items-center iframe-close" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times pe-2 fs-1" }, null, -1))
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "iframeLoading",
  class: "h-100 w-100 d-flex justify-content-center align-items-center position-absolute z-index-1"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary h-150px w-150px",
    role: "status"
  })
], -1))
const _hoisted_124 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_control_scale = _resolveComponent("l-control-scale")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_l_popup = _resolveComponent("l-popup")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_circle = _resolveComponent("l-circle")!
  const _component_l_polygon = _resolveComponent("l-polygon")!
  const _component_l_polyline = _resolveComponent("l-polyline")!
  const _component_l_geo_json = _resolveComponent("l-geo-json")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_l_control = _resolveComponent("l-control")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_l_map = _resolveComponent("l-map")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_news_drop_down = _resolveComponent("news-drop-down")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_l_map, {
        ref: "companyMap",
        id: "companyMap",
        options: _ctx.mapOptions,
        zoom: _ctx.zoom,
        "onUpdate:zoom": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.zoom) = $event)),
        "max-zoom": 18,
        "min-zoom": 9,
        "max-bounds": _ctx.bounds,
        center: _ctx.center,
        zoomAnimation: true,
        onClick: _ctx.handleDrawMarker,
        onReady: _ctx.PluginPrep,
        onLocationFound: _ctx.locationFound,
        onLocationerror: _ctx.locationError
      }, {
        default: _withCtx(() => [
          _createVNode(_component_l_tile_layer, {
            url: _ctx.selectedTile.url,
            "layer-type": "base",
            attribution: '',
            name: _ctx.selectedTile.name,
            option: { noWrap: true }
          }, null, 8, ["url", "name"]),
          _createVNode(_component_l_control_scale, {
            position: "bottomright",
            imperial: false,
            metric: true
          }),
          (_ctx.locationList.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.locationList, (item) => {
                return (_openBlock(), _createBlock(_component_l_marker, {
                  icon: _ctx.customIcon,
                  "lat-lng": [item.latitude, item.longitude],
                  ref_for: true,
                  ref: el => _ctx.markerRefs[item.id] = el
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_l_popup, {
                      options: { closeButton: false, className: 'customPopup' },
                      class: "d-flex flex-column align-items-enter justify-content-center overflow-hidden w-250px bg-white rounded overflow-hidden shadow"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", {
                            class: "h-150px w-250px d-flex align-items-end justify-content-center",
                            style: _normalizeStyle('background-image: url(' + (item.image ? (item.image) : 'img/default-image.jpg') + '); background-size:cover; background-position: center; ')
                          }, [
                            _createVNode(_component_el_button, {
                              class: "mb-2 bg-light-primary bg-hover-primary border-primary text-primary text-hover-light",
                              size: "small",
                              onClick: ($event: any) => (_ctx.handleOpenLocationUrl(item.url)),
                              plain: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4,
                                _createTextVNode("Xem thêm ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ], 4),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(item.name ? item.name : ""), 1),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(item.address ? item.address : ""), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_l_tooltip, {
                      options: {direction:'bottom' , offset:[0, 25]},
                      class: "fs-5"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.isEN ? item.enName : item.name)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["icon", "lat-lng"]))
              }), 256))
            : _createCommentVNode("", true),
          (_ctx.action != 0 && _ctx.drawnMarkers.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawnMarkers, (item, index) => {
                  return (_openBlock(), _createBlock(_component_l_circle, {
                    class: "circle",
                    key: index,
                    "lat-lng": (item as L.LatLngExpression),
                    radius: 6,
                    weight: 3,
                    fillOpacity: 0.3,
                    color: _ctx.circleColor
                  }, null, 8, ["lat-lng", "color"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.drawnMarkers.length >= 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.action == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_l_polygon, {
                        "lat-lngs": _ctx.drawnLines,
                        weight: 1,
                        color: "#000"
                      }, null, 8, ["lat-lngs"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.action == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_l_polyline, {
                        "lat-lngs": _ctx.drawnLines,
                        weight: 1,
                        color: "#000"
                      }, null, 8, ["lat-lngs"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.geoData && _ctx.action == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_l_marker, {
                  "lat-lng": ([_ctx.geoData.latitude, _ctx.geoData.longitude] as L.LatLngExpression)
                }, null, 8, ["lat-lng"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.highLightDistrict)
            ? (_openBlock(), _createBlock(_component_l_geo_json, {
                key: 4,
                geojson: _ctx.districtBorders,
                options: { 'dashArray': '10 0' }
              }, null, 8, ["geojson"]))
            : _createCommentVNode("", true),
          _createVNode(_component_l_control, {
            class: _normalizeClass((_ctx.windowWidth < 768) ? 'w-50px leaflet-control' : ' leaflet-control')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                gutter: 10,
                justify: "center",
                align: "top"
              }, {
                default: _withCtx(() => [
                  (!(_ctx.windowWidth < 768))
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        xs: 24,
                        sm: 18,
                        md: 18,
                        lg: 18,
                        xl: 18,
                        class: _normalizeClass((_ctx.windowWidth < 768) ? 'w-50px' : 'w-175px')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, {
                            gutter: 10,
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "locate",
                                xs: 24,
                                sm: 8,
                                md: 8,
                                lg: 8,
                                xl: 8
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_el_button, {
                                      title: "Định vị",
                                      class: "h-100 w-100 border-0 primaryGradient text-white d-flex justify-content-center align-items-center",
                                      onClick: _ctx.locateUser
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]),
                                _: 1
                              }),
                              (!(_ctx.windowWidth < 768))
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 0,
                                    class: "zoomControl",
                                    xs: 24,
                                    sm: 16,
                                    md: 16,
                                    lg: 16,
                                    xl: 16
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _createElementVNode("div", {
                                            class: "w-100 cursor-pointer h-100 d-flex justify-content-center align-items-center",
                                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args))),
                                            title: (_ctx.isEN ? 'Zoom in' : 'Phóng to')
                                          }, _hoisted_19, 8, _hoisted_17),
                                          _hoisted_20,
                                          _createElementVNode("div", {
                                            class: "w-100 cursor-pointer h-100 d-flex justify-content-center align-items-center",
                                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args))),
                                            title: (_ctx.isEN ? 'Zoom out' : 'Thu nhỏ')
                                          }, _hoisted_23, 8, _hoisted_21)
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          (!(_ctx.windowWidth < 768))
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                xs: 24,
                                sm: 24,
                                md: 24,
                                lg: 24,
                                xl: 24
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("span", _hoisted_26, _toDisplayString((_ctx.tempC.toFixed(0) + "°C")), 1),
                                      _createTextVNode(),
                                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.locationName), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("span", null, _toDisplayString((_ctx.isEN ? "Wind" : "Gió")) + ":", 1),
                                          _createElementVNode("span", _hoisted_30, _toDisplayString((_ctx.windSpeed * 1000 /
                          3600).toFixed(2) + "m/s"), 1)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("span", null, _toDisplayString((_ctx.isEN ? "Humidity" : "Độ ẩm")) + ":", 1),
                                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.humidity + "%"), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        (_ctx.iconUrl)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              class: "w-50px h-50px",
                                              src: _ctx.iconUrl
                                            }, null, 8, _hoisted_32))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_col, {
                    xs: 24,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    xl: 6,
                    gutter: 10,
                    style: {"margin-top":"56px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { class: "mb-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_el_button, {
                              title: "Home",
                              class: "primaryGradient text-white d-flex justify-content-center align-items-center h-100 w-100 border-0",
                              onClick: _ctx.handleMoveToCenter
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { class: "mb-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", {
                              class: "d-flex justify-content-center align-items-end h-100 w-100 cursor-pointer overflow-hidden border-0",
                              title: _ctx.isEN ? 'Language' : 'Ngôn ngữ',
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEN = !_ctx.isEN)),
                              style: _normalizeStyle('background-image: url(\'' + (_ctx.isEN ? _ctx.language[1].img : _ctx.language[0].img) + '\'); background-size: cover; filter:contrast()')
                            }, null, 12, _hoisted_36)
                          ])
                        ]),
                        _: 1
                      }),
                      ((_ctx.windowWidth < 768))
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_el_button, {
                                  title: (_ctx.isEN ? 'Locate' : 'Định vị'),
                                  class: "primaryGradient text-white d-flex justify-content-center align-items-center h-100 w-100 border-0",
                                  onClick: _ctx.locateUser
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_38
                                  ]),
                                  _: 1
                                }, 8, ["title", "onClick"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_row, { class: "mb-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", {
                              class: "d-flex justify-content-center align-items-end h-100 w-100 cursor-pointer overflow-hidden border-0",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleLayerControl && _ctx.toggleLayerControl(...args))),
                              title: (_ctx.isEN ? 'Map' : 'Bản đồ'),
                              style: _normalizeStyle('background-image: url(\'' + _ctx.selectedTile.img + '\'); background-size: cover;')
                            }, [
                              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.selectedTile.shortName), 1)
                            ], 12, _hoisted_40)
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.layerControlOpen)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tileProviders, (tileProvider, index) => {
                            return (_openBlock(), _createBlock(_component_el_row, { class: "mb-2" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", {
                                    class: "d-flex justify-content-center align-items-end h-100 w-100 cursor-pointer overflow-hidden border-0",
                                    style: _normalizeStyle('background-image: url(\'' + tileProvider.img + '\'); background-size: cover;'),
                                    onClick: ($event: any) => (_ctx.handleTileChange(tileProvider, index))
                                  }, [
                                    _createElementVNode("span", _hoisted_44, _toDisplayString(tileProvider.shortName), 1)
                                  ], 12, _hoisted_43)
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_row, { class: "mb-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_el_button, {
                              class: _normalizeClass('d-flex justify-content-center align-items-center h-100 w-100 text-white border-0'
                    + (_ctx.toolboxOpen ? ' secondaryGradient' : ' primaryGradient')),
                              title: (_ctx.isEN ? 'Tools' : 'Công cụ'),
                              onClick: _ctx.toggleToolBox
                            }, {
                              default: _withCtx(() => [
                                _hoisted_46
                              ]),
                              _: 1
                            }, 8, ["class", "title", "onClick"])
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.toolboxOpen)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 2,
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_47, [
                                _createVNode(_component_el_button, {
                                  class: "primaryGradient text-white d-flex justify-content-center align-items-center h-100 w-100 border-0",
                                  title: (_ctx.isEN ? 'Area measure' : 'Đo điện tích'),
                                  onClick: _ctx.handleDrawPolygon
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_48
                                  ]),
                                  _: 1
                                }, 8, ["title", "onClick"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.toolboxOpen)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 3,
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_49, [
                                _createVNode(_component_el_button, {
                                  class: "primaryGradient text-white d-flex justify-content-center align-items-center h-100 w-100 border-0",
                                  title: (_ctx.isEN ? 'Lenght measure' : 'Đo khoảng cách'),
                                  onClick: _ctx.handleDrawLine
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_50
                                  ]),
                                  _: 1
                                }, 8, ["title", "onClick"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.toolboxOpen)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 4,
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_el_button, {
                                  class: "primaryGradient text-white d-flex justify-content-center align-items-center h-100 w-100 border-0",
                                  title: (_ctx.isEN ? 'Geo info' : 'Thông tin vị trí'),
                                  onClick: _ctx.handleFindInfo
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_52
                                  ]),
                                  _: 1
                                }, 8, ["title", "onClick"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.toolboxOpen)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 5,
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_53, [
                                _createVNode(_component_el_button, {
                                  class: "primaryGradient text-white d-flex justify-content-center align-items-center h-100 w-100 border-0",
                                  title: (_ctx.isEN ? 'Download map' : 'In bản đồ'),
                                  onClick: _ctx.handleScreenShot
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_54
                                  ]),
                                  _: 1
                                }, 8, ["title", "onClick"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_l_control, { position: "bottomright" }, {
            default: _withCtx(() => [
              (_ctx.drawnMarkers.length > 0)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "leaflet-bar d-flex justify-content-center align-items-center w-50px h-50px",
                    title: _ctx.isEN ? 'Undo' : 'Hoàn tác',
                    onClick: _ctx.handleUndo
                  }, {
                    default: _withCtx(() => [
                      _hoisted_55
                    ]),
                    _: 1
                  }, 8, ["title", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_l_control, { position: "topleft" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    (!(_ctx.windowWidth < 768))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_map",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal(true))),
                          class: "p-3 listBtn d-flex justify-content-center align-items-center cursor-pointer"
                        }, _hoisted_60))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mobileToggle && _ctx.mobileToggle(...args))),
                          class: "p-3 listBtn d-flex justify-content-center align-items-center cursor-pointer"
                        }, _hoisted_62)),
                    _createVNode(_component_el_input, {
                      size: "small",
                      type: "search",
                      class: "searchField text-white",
                      modelValue: _ctx.searchString,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchString) = $event)),
                      placeholder: (_ctx.isEN ? 'Find location' : 'Tìm kiếm địa chỉ'),
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter(_ctx.searchString)))
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "searchList px-3 py-2 bg-hover-primary text-white cursor-pointer",
                      onClick: ($event: any) => (_ctx.flyToOnClick(item, item.id))
                    }, _toDisplayString((_ctx.isEN ? item.enName ? item.enName : item.name : item.name)), 9, _hoisted_63))
                  }), 256))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_l_control, { position: "topleft" }, {
            default: _withCtx(() => [
              (_ctx.action == 1 || _ctx.action == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", null, [
                        (_ctx.action == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                              _createTextVNode(_toDisplayString((_ctx.isEN ? "Area" : "Diện tích")) + ": " + _toDisplayString(_ctx.displayResult) + " ", 1),
                              (_ctx.unit == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                                    _createTextVNode("(km"),
                                    _hoisted_68,
                                    _createTextVNode(")")
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.unit == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                                    _createTextVNode("(m"),
                                    _hoisted_70,
                                    _createTextVNode(")")
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.action == 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                              _createTextVNode(_toDisplayString((_ctx.isEN ? "Length" : "Khoảng cách")) + ": " + _toDisplayString(_ctx.displayResult) + " ", 1),
                              (_ctx.unit == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_72, "(km)"))
                                : _createCommentVNode("", true),
                              (_ctx.unit == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_73, "(m)"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                        class: "me-2"
                      }, _hoisted_75)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_l_control, {
            position: (_ctx.windowWidth < 768) ? 'bottomleft' : 'topleft'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass((_ctx.geoResult.lat ? 'd-block' : 'd-none') + ' leaflet-bar  card'),
                style: {"min-width":"250px"}
              }, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("h2", _hoisted_77, _toDisplayString((_ctx.isEN ? "Location info" : "Thông tin vị trí")), 1),
                  _createElementVNode("div", {
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                    class: "btn btn-sm btn-icon btn-active-color-primary"
                  }, [
                    _createElementVNode("span", _hoisted_78, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_el_form, {
                    "label-width": "100px",
                    class: "flex-column"
                  }, {
                    default: _withCtx(() => [
                      (!(_ctx.windowWidth < 768))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: (_ctx.isEN ? 'City:' : 'Tỉnh thành:')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(_ctx.geoResult.city), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      (!(_ctx.windowWidth < 768))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: (_ctx.isEN ? 'District:' : 'Quận huyện:')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(_ctx.geoResult.district), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      (!(_ctx.windowWidth < 768))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: (_ctx.isEN ? 'Ward:' : 'Xã phường:')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(_ctx.geoResult.ward), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      ((_ctx.windowWidth < 768))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: (_ctx.isEN ? 'Location:' : 'Địa chỉ:')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.geoResult.city + (_ctx.geoResult.district ? (", " + _ctx.geoResult.district) : "") +
                      (_ctx.geoResult.ward ? (", " + _ctx.geoResult.ward) : "")), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: (_ctx.isEN ? 'Longitude:' : 'Kinh độ:')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.geoResult.lon), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: (_ctx.isEN ? 'Latitude:' : 'Vĩ độ:')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.geoResult.lat), 1)
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  })
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["position"])
        ]),
        _: 1
      }, 8, ["options", "zoom", "max-bounds", "center", "onClick", "onReady", "onLocationFound", "onLocationerror"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass('swiperHolder d-flex flex-column secondaryGradient' + ((!_ctx.expanded) ? ' close' : ''))
    }, [
      _createElementVNode("div", _hoisted_81, [
        _hoisted_82,
        _createElementVNode("div", {
          class: _normalizeClass(' d-flex w-100' + ((_ctx.windowWidth < 768) ? ' justify-content-center pe-20' : ' justify-content-center'))
        }, [
          (!(_ctx.windowWidth < 768))
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _createElementVNode("div", {
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleMoveToCenter && _ctx.handleMoveToCenter(...args))),
                  title: "Home",
                  style: {"background-image":"url('media/svg/shapes/hexagon.svg')","background-size":"cover"},
                  class: "footerButton position-relative bottom-100 d-flex z-index-2 align-items-center justify-content-center cursor-pointer"
                }, _hoisted_85)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_86, [
            (!(_ctx.windowWidth < 768))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  title: _ctx.isEN ? 'List' : 'Danh sách',
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_map",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openModal(true))),
                  style: {"background-image":"url('media/svg/shapes/hexagon.svg')","background-size":"cover"},
                  class: "footerButton position-relative bottom-100 d-flex z-index-2 align-items-center justify-content-center cursor-pointer"
                }, _hoisted_89, 8, _hoisted_87))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  title: _ctx.isEN ? 'List' : 'Danh sách',
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.mobileToggle && _ctx.mobileToggle(...args))),
                  style: {"background-image":"url('media/svg/shapes/hexagon.svg')","background-size":"cover"},
                  class: _normalizeClass('mobileFooterButton ' + (_ctx.expanded ? 'expanded' : '') + ' position-relative bottom-100 d-flex z-index-2 align-items-center justify-content-center cursor-pointer')
                }, _hoisted_92, 10, _hoisted_90))
          ])
        ], 2),
        (!(_ctx.windowWidth < 768))
          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
              _createVNode(_component_el_button, {
                class: "expander rounded-0 rounded-top border-0 accentGradient text-white text-hover-primary",
                onClick: _ctx.expandSwiper
              }, {
                default: _withCtx(() => [
                  _hoisted_94,
                  _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.expanded ? (_ctx.isEN ? 'Shrink' : 'Thu nhỏ') : (_ctx.isEN ? 'Expand' : 'Mở rộng')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (!(_ctx.windowWidth < 768) && _ctx.locationList.length > 0)
        ? (_openBlock(), _createBlock(_component_swiper, {
            key: 0,
            style: {},
            reactive: "",
            breakpoints: {
        720: {
          slidesPerView: 7,
          spaceBetween: 10
        },
        1240: {
          slidesPerView: 10,
          spaceBetween: 10
        }
      },
            slidesPerView: 3,
            spaceBetween: 20,
            loop: true,
            pagination: { clickable: true, },
            navigation: true,
            modules: _ctx.swiperOptions.modules,
            class: "mySwiper p-2 position-relative z-index-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationList, (item) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  key: item.id,
                  class: "rollItem hover cursor-pointer shadow-sm rounded border",
                  style: _normalizeStyle('background-image: url(\'' + (item.image ? (item.image) : 'img/default-image.jpg') + '\');'),
                  onClick: ($event: any) => (_ctx.flyToOnClick(item, item.id))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "px-2 itemInfo text-white",
                      title: _ctx.isEN ? item.enName ? item.enName : item.name : item.name
                    }, [
                      _createElementVNode("div", _hoisted_97, [
                        _hoisted_98,
                        _createTextVNode(" " + _toDisplayString(_ctx.isEN ? item.enName ? item.enName : item.name : item.name), 1)
                      ])
                    ], 8, _hoisted_96)
                  ]),
                  _: 2
                }, 1032, ["style", "onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modules"]))
        : _createCommentVNode("", true),
      ((_ctx.windowWidth < 768))
        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "d-flex bg-white p-2 m-2 my-4 border border-2 border-gray rounded shadow",
                onClick: ($event: any) => (_ctx.flyToOnClick(item, item.id))
              }, [
                _createElementVNode("div", {
                  class: "locationImg rounded",
                  style: _normalizeStyle('background-image: url(\'' + (item.image ? (item.image) : 'img/default-image.jpg') + '\');')
                }, null, 4),
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.isEN ? item.enName ? item.enName : item.name : item.name), 1)
                ])
              ], 8, _hoisted_100))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_102, [
      _createElementVNode("div", _hoisted_103, [
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("h2", _hoisted_106, _toDisplayString(_ctx.modalTitle), 1),
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("span", _hoisted_108, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass('modal-body ' + (!_ctx.modalType ? 'p-0' : 'pt-2'))
          }, [
            (_ctx.modalType)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass('d-flex mb-2 ' + (_ctx.windowWidth <= 425 ? 'flex-column justify-content-end' : 'justify-content-between '))
                }, [
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.totalFilteredLocation + " Địa điểm"), 1)
                    ])
                  ]),
                  _createVNode(_component_el_pagination, {
                    class: "modalPagination",
                    onCurrentChange: _ctx.handleChangePage,
                    total: _ctx.totalFilteredLocation,
                    "page-size": _ctx.pageSize,
                    layout: "prev, pager, next"
                  }, null, 8, ["onCurrentChange", "total", "page-size"])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.modalType)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(' modalLocationList ' + ((_ctx.windowWidth <= 425) ? 'mh-450px' : 'mh-500px'))
                }, [
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLocationList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_col, {
                          xs: 24,
                          sm: 6,
                          md: 6,
                          lg: 6,
                          xl: 6,
                          key: item.id,
                          class: "mb-2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass('rollItem hover cursor-pointer shadow-sm rounded border h-150px '/*  + (windowWidth <= 425 ? 'h-150px' : 'h-150px') */),
                              style: _normalizeStyle('background-image: url(\'' + (item.image ? (item.image) : 'img/default-image.jpg') + '\');'),
                              onClick: ($event: any) => {_ctx.hideModal(_ctx.mapModalRef as HTMLElement); _ctx.flyToOnClick(item, item.id)}
                            }, [
                              _createElementVNode("div", {
                                class: "px-2 itemInfo text-white",
                                title: _ctx.isEN ? item.enName ? item.enName : item.name : item.name
                              }, [
                                _createElementVNode("span", _hoisted_113, [
                                  _hoisted_114,
                                  _createTextVNode(" " + _toDisplayString(_ctx.isEN ? item.enName ? item.enName : item.name : item.name), 1)
                                ])
                              ], 8, _hoisted_112)
                            ], 12, _hoisted_111)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass('w-100 px-10 mt-5' + ((_ctx.windowWidth < 768) ? ' h-200px' : ' h-600px'))
                }, [
                  _createElementVNode("iframe", {
                    class: _normalizeClass('w-100' + ((_ctx.windowWidth < 768) ? ' h-200px' : ' h-600px')),
                    src: _ctx.introductionVideo
                  }, "\n              ", 10, _hoisted_115)
                ], 2)),
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("h2", _hoisted_117, _toDisplayString(_ctx.introductionTitle), 1)
            ])
          ], 2)
        ])
      ])
    ], 512),
    (_ctx.openIframe)
      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
          _createElementVNode("div", _hoisted_119, [
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("span", {
                class: "closeIframe cursor-pointer fs-1 fw-bolder text-white",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleCLoseLocationUrl && _ctx.handleCLoseLocationUrl(...args)))
              }, _hoisted_122)
            ]),
            _hoisted_123,
            _createElementVNode("iframe", {
              src: _ctx.iframeURL,
              class: "d-flex position-absolute z-index-2 h-100 w-100",
              id: "vr360iFrame"
            }, "\n        ", 8, _hoisted_124)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_news_drop_down, {
      id: "newDropDownId",
      onEnter: _ctx.disableScrollWheel,
      onLeave: _ctx.enableScrollWheel,
      isEN: _ctx.isEN,
      isMobile: (_ctx.windowWidth <= 425)
    }, null, 8, ["onEnter", "onLeave", "isEN", "isMobile"])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}